<script setup lang="ts">
import OptionGroup from '../libs/optionGroup/optionGroup.vue';

import type { Props } from './types';

const model = defineModel<Props['modelValue']>({
	required: true,
});

defineProps<Props>();
</script>

<template>
	<OptionGroup
		class="top-radioGroup"
		v-model="model"
		:items="$props.items"
		:size="$props.size"
		:showIndicator="$props.showIndicator"
		:isError="$props.isError"
	>
		<slot/>
	</OptionGroup>
</template>
